import produce from 'immer';
import { createReducer } from 'typesafe-actions';
import {
  GET_BID_CHANCE_LIST,
  GET_BID_CHANCE_LIST_ERROR,
  GET_BID_CHANCE_LIST_SUCCESS,
  UPDATE_BID_CHANCE,
  UPDATE_BID_CHANCE_ERROR,
  UPDATE_BID_CHANCE_SUCCESS,
  GET_BID_CHANCE_DETAIL,
  GET_BID_CHANCE_DETAIL_SUCCESS,
  GET_BID_CHANCE_DETAIL_ERROR,
  CREATE_BID_PROPOSAL,
  CREATE_BID_PROPOSAL_SUCCESS,
  CREATE_BID_PROPOSAL_ERROR,
  GET_BID_CHANCE_DETAIL2,
  GET_BID_CHANCE_DETAIL2_ERROR,
  GET_BID_CHANCE_DETAIL2_SUCCESS,
} from './actions';
import { BidChancesAction, BidChancesState } from './types';

const initialState: BidChancesState = {
  bidChances: {
    loading: false,
    data: null,
    error: null,
  },
  bidChance: {
    loading: false,
    data: null,
    error: null,
  },
};

const bidChances = createReducer<BidChancesState, BidChancesAction>(
  initialState,
  {
    [GET_BID_CHANCE_LIST]: (state) => ({
      ...state,
      bidChances: {
        loading: true,
        error: null,
        data: null,
      },
    }),

    [GET_BID_CHANCE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      bidChances: {
        loading: false,
        error: null,
        data: action.payload,
      },
    }),
    [GET_BID_CHANCE_LIST_ERROR]: (state, action) => ({
      ...state,
      bidChances: {
        loading: false,
        error: action.payload,
        data: null,
      },
    }),
    /*
    [CREATE_BID_CHANCE]: (state) =>
      produce(state, (draft) => {
        draft.bidChances.loading = true;
        draft.bidChances.error = null;
      }),
    [CREATE_BID_CHANCE_SUCCESS]: (state, action) =>
      produce(state, (draft) => {
        draft.bidChances.data?.push(action.payload);
        draft.bidChances.loading = false;
        draft.bidChances.error = null;
      }),
    [CREATE_BID_CHANCE_ERROR]: (state, action) =>
      produce(state, (draft) => {
        draft.bidChances.loading = false;
        draft.bidChances.error = action.payload;
      }),
    */

    [UPDATE_BID_CHANCE]: (state) =>
      produce(state, (draft) => {
        draft.bidChance.loading = true;
        draft.bidChance.error = null;
      }),
    [UPDATE_BID_CHANCE_SUCCESS]: (state, action) =>
      produce(state, (draft) => {
        if (draft.bidChance.data !== null) {
          draft.bidChance.data = action.payload;
        }
        draft.bidChance.loading = false;
        draft.bidChance.error = null;
      }),
    [UPDATE_BID_CHANCE_ERROR]: (state, action) =>
      produce(state, (draft) => {
        draft.bidChance.loading = false;
        draft.bidChance.error = action.payload;
      }),

    /*
    [DELETE_BID_CHANCE]: (state) =>
      produce(state, (draft) => {
        draft.bidChances.loading = true;
        draft.bidChances.error = null;
      }),
    [DELETE_BID_CHANCE_SUCCESS]: (state, action) =>
      produce(state, (draft) => {
        if (draft.bidChances.data !== null) {
          const index = draft.bidChances.data.findIndex(
            (bidChance) => bidChance.id === action.payload,
          );
          draft.bidChances.data.splice(index, 1);
        }
        draft.bidChances.loading = false;
        draft.bidChances.error = null;
      }),
    [DELETE_BID_CHANCE_ERROR]: (state, action) =>
      produce(state, (draft) => {
        draft.bidChances.loading = false;
        draft.bidChances.error = action.payload;
      }),
    */

    [GET_BID_CHANCE_DETAIL]: (state) => ({
      ...state,
      bidChance: {
        loading: true,
        error: null,
        data: null,
      },
    }),
    [GET_BID_CHANCE_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      bidChance: {
        loading: false,
        error: null,
        data: action.payload,
      },
    }),
    [GET_BID_CHANCE_DETAIL_ERROR]: (state, action) => ({
      ...state,
      bidChance: {
        loading: false,
        error: action.payload,
        data: null,
      },
    }),

    [CREATE_BID_PROPOSAL]: (state) =>
      produce(state, (draft) => {
        draft.bidChance.loading = true;
        draft.bidChance.error = null;
      }),
    [CREATE_BID_PROPOSAL_SUCCESS]: (state, action) =>
      produce(state, (draft) => {
        if (draft.bidChance.data !== null) {
          draft.bidChance.data = action.payload;
        }
        draft.bidChance.loading = false;
        draft.bidChance.error = null;
      }),
    [CREATE_BID_PROPOSAL_ERROR]: (state, action) =>
      produce(state, (draft) => {
        draft.bidChance.loading = false;
        draft.bidChance.error = action.payload;
      }),

    [GET_BID_CHANCE_DETAIL2]: (state) => ({
      ...state,
      bidChance: {
        loading: true,
        error: null,
        data: null,
      },
    }),
    [GET_BID_CHANCE_DETAIL2_SUCCESS]: (state, action) => ({
      ...state,
      bidChance: {
        loading: false,
        error: null,
        data: action.payload,
      },
    }),
    [GET_BID_CHANCE_DETAIL2_ERROR]: (state, action) => ({
      ...state,
      bidChance: {
        loading: false,
        error: action.payload,
        data: null,
      },
    }),
  },
);

export default bidChances;
